import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { ChevronDown, Pin, Clock } from "lucide-react";

// PATCH 35 M12 — fast project switcher with recently-viewed + pinned (localStorage), not a plain dropdown.
const REC_KEY = "kadana_recent_projects";
const PIN_KEY = "kadana_pinned_projects";
const read = (k) => { try { return JSON.parse(localStorage.getItem(k) || "[]"); } catch { return []; } };

export function recordRecent(p) {
  if (!p?.id) return;
  const list = read(REC_KEY).filter((x) => x.id !== p.id);
  list.unshift({ id: p.id, name: p.name });
  try { localStorage.setItem(REC_KEY, JSON.stringify(list.slice(0, 8))); } catch { /* ignore */ }
}

export default function ProjectSwitcher({ orgId }) {
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [all, setAll] = useState([]);
  const [pins, setPins] = useState(read(PIN_KEY));
  useEffect(() => { if (orgId) api.get(`/orgs/${orgId}/projects`).then((r) => setAll(r.data || [])).catch(() => {}); }, [orgId]);
  const recent = read(REC_KEY);
  const togglePin = (p) => {
    const next = pins.find((x) => x.id === p.id) ? pins.filter((x) => x.id !== p.id) : [...pins, { id: p.id, name: p.name }];
    setPins(next); try { localStorage.setItem(PIN_KEY, JSON.stringify(next)); } catch { /* ignore */ }
  };
  const go = (id) => { setOpen(false); nav(`/project/${id}`); };
  const Row = ({ p, icon: Icon }) => (
    <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 8px" }}>
      {Icon && <Icon size={12} className="k-muted" />}
      <button className="k-link" data-testid={`switch-to-${p.id}`} style={{ flex: 1, textAlign: "left", fontSize: 13 }} onClick={() => go(p.id)}>{p.name}</button>
      <button className="k-link" aria-label="Pin project" onClick={() => togglePin(p)} style={{ opacity: pins.find((x) => x.id === p.id) ? 1 : 0.4 }}><Pin size={12} /></button>
    </div>
  );
  return (
    <div style={{ position: "relative", marginBottom: 14 }} data-testid="project-switcher">
      <button className="k-control" onClick={() => setOpen((o) => !o)} data-testid="project-switcher-toggle"
        style={{ display: "flex", alignItems: "center", gap: 6, width: "100%", cursor: "pointer", fontSize: 13 }}>
        Projects <ChevronDown size={14} style={{ marginLeft: "auto" }} />
      </button>
      {open && (
        <div className="k-container k-fadein" style={{ position: "absolute", zIndex: 40, marginTop: 4, width: 260, padding: 8, maxHeight: 360, overflowY: "auto" }}>
          {pins.length > 0 && <><div className="k-muted" style={{ fontSize: 11, padding: "4px 8px" }}>Pinned</div>{pins.map((p) => <Row key={"pin" + p.id} p={p} icon={Pin} />)}</>}
          {recent.length > 0 && <><div className="k-muted" style={{ fontSize: 11, padding: "4px 8px" }}>Recent</div>{recent.map((p) => <Row key={"rec" + p.id} p={p} icon={Clock} />)}</>}
          <div className="k-muted" style={{ fontSize: 11, padding: "4px 8px" }}>All projects</div>
          {all.length ? all.map((p) => <Row key={p.id} p={p} />) : <div className="k-muted" style={{ fontSize: 12, padding: 8 }}>No projects yet.</div>}
        </div>
      )}
    </div>
  );
}
